import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent implements OnInit, AfterViewInit {

    @ViewChild('wrapper')
    public wrapper: ElementRef;

    @ViewChild('canvas')
    public canvas: ElementRef;

    @Input('height')
    public height = 400;

    @Input('chartData')
    public chartData = {
        value: 10
    };

    private cx: CanvasRenderingContext2D;

    constructor(private decimalPipe: DecimalPipe) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        this.cx = canvasEl.getContext('2d');

        canvasEl.width = this.wrapper.nativeElement.offsetWidth;
        canvasEl.height = this.height;

        const centerX = canvasEl.width / 2;
        const centerY = canvasEl.height / 2 - 50;
        const radius = centerY - 2;

        this.drawPieSlice(this.cx, centerX, centerY, radius, 0, Math.PI * 2, '#EAECED');
        this.drawPieSlice(this.cx, centerX, centerY, radius, 0, Math.PI * 2 * this.chartData.value / 100, '#96A2A6');

        this.cx.fillStyle = 'black';
        this.cx.textAlign = 'center';
        this.cx.font = 20 + 'px Arial';
        this.cx.fillText(this.decimalPipe.transform(this.chartData.value , '1.2-2') + ' %', canvasEl. width / 2, canvasEl.height - 50, canvasEl.width);

    }

    drawLine(ctx, startX, startY, endX, endY) {
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.stroke();
    }

    drawArc(ctx, centerX, centerY, radius, startAngle, endAngle) {
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.stroke();
    }

    drawPieSlice(ctx, centerX, centerY, radius, startAngle, endAngle, color) {
        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fill();
    }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/charts/pie-chart/pie-chart.component.ts